import { PageTitle } from '@/components/seo/page-title';
import React from 'react';
import { Image, KeyboardAvoidingView, ScrollView, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

interface AuthScreenLayoutProps {
  title: string;
  heading?: string;
  subheading?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  paddingHorizontal?: number;
}

export function AuthScreenLayout({
  title,
  heading,
  subheading,
  children,
  footer,
  paddingHorizontal = 16,
}: AuthScreenLayoutProps) {
  return (
    <View className="flex-1">
      <PageTitle title={title} />
      <View className="flex-1">
        <SafeAreaView className="flex-1">
          <KeyboardAvoidingView
            behavior={process.env.EXPO_OS === 'ios' ? 'padding' : 'height'}
            className="flex-1"
          >
            <ScrollView
              className="flex-1"
              contentContainerStyle={{
                flexGrow: 1,
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                paddingHorizontal,
                paddingVertical: 20,
              }}
              showsVerticalScrollIndicator={false}
            >
              <View style={{ width: '100%', maxWidth: 420, alignSelf: 'center' }}>
                <View className="items-center mb-8">
                  <Image
                    source={require('@/assets/images/flavrly-app-logo-dark.svg')}
                    style={{ width: '100%', maxWidth: 300, height: 200 }}
                    resizeMode="contain"
                    accessible={false}
                  />
                  <Text className="text-xs mt-1 tracking-widest text-warm-gray-100">
                    EAT LIKE A LOCAL
                  </Text>
                  {heading && (
                    <Text className="text-3xl font-bold mt-4 text-warm-gray-100">
                      {heading}
                    </Text>
                  )}
                  {subheading && (
                    <Text className="text-base mt-2 text-warm-gray-100">
                      {subheading}
                    </Text>
                  )}
                </View>
                {children}
                {footer}
              </View>
            </ScrollView>
          </KeyboardAvoidingView>
        </SafeAreaView>
      </View>
    </View>
  );
}
